// extracted by mini-css-extract-plugin
module.exports = {"canvas":"BookStack3D_canvas__iqSBJ"};